import { render, staticRenderFns } from "./Mentions.vue?vue&type=template&id=05e9cce8&"
import script from "./Mentions.vue?vue&type=script&lang=js&"
export * from "./Mentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports